(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-card-menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMenu(root) {
    if (!root || root.dataset.pcmReady === '1') return;
    root.dataset.pcmReady = '1';

    var delay = parseInt(root.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 600;

    var viewport = root.querySelector('.pcm__viewport');
    var nav      = root.querySelector('.pcm__nav');
    var prevBtn  = root.querySelector('.pcm__arrow--prev');
    var nextBtn  = root.querySelector('.pcm__arrow--next');
    var cards    = Array.prototype.slice.call(root.querySelectorAll('.pcm__card'));

    /* ---- Flechas de navegacion ---- */
    function maxScroll() {
      return viewport ? viewport.scrollWidth - viewport.clientWidth : 0;
    }
    function refreshArrows() {
      if (!viewport || !nav) return;
      var overflowing = maxScroll() > 4;
      nav.classList.toggle('is-hidden', !overflowing);
      if (!overflowing) return;
      var x = viewport.scrollLeft;
      if (prevBtn) prevBtn.disabled = x <= 1;
      if (nextBtn) nextBtn.disabled = x >= maxScroll() - 1;
    }
    function stepSize() {
      return Math.max(200, Math.round(viewport.clientWidth * 0.6));
    }
    if (prevBtn && viewport) {
      prevBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: -stepSize(), behavior: 'smooth' });
      });
    }
    if (nextBtn && viewport) {
      nextBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: stepSize(), behavior: 'smooth' });
      });
    }
    if (viewport) {
      viewport.addEventListener('scroll', refreshArrows, { passive: true });
    }
    window.addEventListener('resize', refreshArrows);
    refreshArrows();
    window.setTimeout(refreshArrows, 350);

    /* ---- Centrar la tarjeta abierta (pagina de proyecto) ---- */
    var selected = root.querySelector('.pcm__card.is-selected');
    if (selected && viewport) {
      window.setTimeout(function () {
        var c = selected.getBoundingClientRect();
        var v = viewport.getBoundingClientRect();
        viewport.scrollLeft += (c.left - v.left) - (v.width - c.width) / 2;
        refreshArrows();
      }, 120);
    }

    /* ---- Titulo al pasar el raton (lo controla el JS, no el CSS) ---- */
    cards.forEach(function (card) {
      var hoverTitle = card.querySelector('.pcm__hover-title');
      if (hoverTitle) {
        hoverTitle.style.display = 'none';
        var showTitle = function () {
          if (!card.classList.contains('is-selected')) {
            hoverTitle.style.display = 'block';
          }
        };
        var hideTitle = function () {
          hoverTitle.style.display = 'none';
        };
        card.addEventListener('mouseenter', showTitle);
        card.addEventListener('mouseleave', hideTitle);
        card.addEventListener('focusin', showTitle);
        card.addEventListener('focusout', hideTitle);
      }
    });

    /* ---- Clic en tarjeta -> abrir y navegar ---- */
    cards.forEach(function (card) {
      var link = card.querySelector('.pcm__link');
      if (!link) return;

      link.addEventListener('click', function (event) {
        if (card.classList.contains('is-selected')) {
          event.preventDefault();
          return;
        }

        var href = link.getAttribute('href');
        if (!href || href === '#') {
          event.preventDefault();
          return;
        }
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
          return;
        }

        event.preventDefault();

        cards.forEach(function (c) {
          c.classList.remove('is-selected');
        });
        card.classList.add('is-selected');
        root.classList.add('pcm--navigating');
        window.setTimeout(refreshArrows, 600);

        window.setTimeout(function () {
          window.location.href = href;
        }, delay);
      });
    });
  }

  function initAll() {
    Array.prototype.slice
      .call(document.querySelectorAll('.pcm'))
      .forEach(initMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector('.pcm')
      : null;
    if (root) initMenu(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
